import DatabaseModel from './DatabaseModel.js';

var LineaNegocio = Object.create(DatabaseModel);

LineaNegocio.model = 'lineanegocio';
LineaNegocio.modelFront = 'lineasnegocio';

export default LineaNegocio;